import { Model, type ModelProps } from '@/infra/model'
import { observable } from 'mobx'
import { Id } from '@/infra/id'
import { unixEpoch } from '@/utils/date-util'

export type InsightProps = ModelProps<Insight>

/**
 * An Insight for a job.
 */
export class Insight extends Model<Insight> {
  id = Id.none
  @observable accessor jobId = Id.none
  @observable accessor prefixContent = ''
  @observable accessor generatedResponse = ''
  @observable accessor dateGenerated = unixEpoch()
  @observable accessor isIrrelevant = false
  @observable accessor dateMarkedIrrelevant: Date | null = null
}
